(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach(function(select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var forms = document.querySelectorAll('.contact-page form');

    function getFieldValue(form, names) {
      for (var i = 0; i < names.length; i += 1) {
        var field = Array.prototype.find.call(form.elements, function(element) {
          return element.name === names[i];
        });

        if (field && typeof field.value === 'string' && field.value.trim() !== '') {
          return field.value.trim();
        }
      }

      return '';
    }

    function updateSubject(form) {
      var subjectField = form.querySelector('[data-contact-subject]');
      if (!subjectField) return;

      var firstName = getFieldValue(form, ['contact[first_name]', 'first_name']);
      var lastName = getFieldValue(form, ['contact[last_name]', 'last_name']);
      var fullName = [firstName, lastName].filter(Boolean).join(' ');
      subjectField.value = fullName ? 'Contact request from ' + fullName : 'Contact request';
    }

    function showFormMessage(form, message, isError) {
      var existing = form.querySelector('[data-lead-alert-message]');
      var notice = existing || document.createElement(isError ? 'div' : 'p');
      notice.setAttribute('data-lead-alert-message', '');
      notice.className = isError ? 'contact-form__errors' : 'contact-form__success';
      notice.textContent = message;
      form.classList.toggle('contact-form--submitted', !isError);

      if (!existing) {
        form.insertBefore(notice, form.firstElementChild);
      }
    }

    function setSubmitLoading(form, isLoading) {
      var submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!submitButton) return;

      if (!submitButton.dataset.originalText) {
        submitButton.dataset.originalText = submitButton.textContent || submitButton.value || 'Submit';
      }

      submitButton.disabled = isLoading;

      if (submitButton.tagName === 'INPUT') {
        submitButton.value = isLoading ? 'Submitting...' : submitButton.dataset.originalText;
        return;
      }

      submitButton.textContent = isLoading ? 'Submitting...' : submitButton.dataset.originalText;
    }

    function createSubmissionId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      return 'contact-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    }

    function getFieldLabel(fieldWrapper, fallback) {
      var label = fieldWrapper && (fieldWrapper.querySelector('label') || fieldWrapper.querySelector('.contact-form__sublabel'));
      if (!label) return fallback || 'Field';

      return label.textContent
        .replace(/\s*\(required\)\s*/ig, '')
        .replace(/\s+/g, ' ')
        .trim() || fallback || 'Field';
    }

    function collectFormFields(form) {
      var rows = [];

      Array.prototype.forEach.call(form.querySelectorAll('.contact-form__field'), function(fieldWrapper) {
        var controls = Array.prototype.slice.call(fieldWrapper.querySelectorAll('input, select, textarea')).filter(function(control) {
          var type = (control.type || '').toLowerCase();
          return type !== 'hidden' && type !== 'submit' && type !== 'button';
        });

        if (!controls.length) return;

        var label = getFieldLabel(fieldWrapper, controls[0].name || controls[0].id);
        var values = [];

        controls.forEach(function(control) {
          var type = (control.type || '').toLowerCase();

          if ((type === 'checkbox' || type === 'radio') && !control.checked) return;
          if (typeof control.value !== 'string') return;

          values.push(control.value.trim());
        });

        rows.push({
          label: label,
          name: controls[0].name || controls[0].id || '',
          value: values.filter(Boolean).join(', ')
        });
      });

      return rows;
    }

    function submitLeadAlert(form, syncMarker) {
      var endpoint = syncMarker.getAttribute('data-customer-sync-url');
      var payload = {
        mode: 'send_inquiry',
        first_name: getFieldValue(form, ['contact[first_name]', 'first_name']),
        last_name: getFieldValue(form, ['contact[last_name]', 'last_name']),
        email: getFieldValue(form, ['contact[email]', 'email']),
        phone: getFieldValue(form, ['contact[phone]', 'phone']),
        inquiry_type: syncMarker.getAttribute('data-inquiry-type') || 'General Contact',
        fields: collectFormFields(form),
        submission_id: createSubmissionId()
      };

      if (!endpoint) {
        return Promise.reject(new Error('Missing lead endpoint.'));
      }

      if (!payload.email) {
        return Promise.reject(new Error('Please enter a valid email before submitting.'));
      }

      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Could not send contact request.');
        }

        return response.json();
      }).then(function(data) {
        if (!data || data.email_sent !== true) {
          throw new Error('Contact request email was not confirmed.');
        }

        return data;
      });
    }

    Array.prototype.forEach.call(forms, function(form) {
      if (!form.querySelector('[data-contact-subject]')) return;
      var syncMarker = form.querySelector('[data-lead-alert-sync]');

      if (syncMarker) {
        form.setAttribute('data-nocaptcha', 'true');
      }

      if (form.querySelector('.contact-form__success')) {
        form.classList.add('contact-form--submitted');
      }

      updateSubject(form);
      form.addEventListener('input', function() {
        updateSubject(form);
      });
      form.addEventListener('change', function() {
        updateSubject(form);
      });
      form.addEventListener('submit', function(event) {
        updateSubject(form);

        if (!syncMarker) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (form.dataset.leadAlertPending === 'true') return;
        form.dataset.leadAlertPending = 'true';
        setSubmitLoading(form, true);

        submitLeadAlert(form, syncMarker).then(function() {
          form.dataset.leadAlertPending = 'false';
          setSubmitLoading(form, false);
          showFormMessage(form, 'Thank you for reaching out. Someone will be in touch with you shortly.', false);
          form.reset();
          updateSubject(form);
        }).catch(function(error) {
          form.dataset.leadAlertPending = 'false';
          setSubmitLoading(form, false);
          showFormMessage(form, error.message || 'We could not send the inquiry. Please try again.', true);
        });
      }, true);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-request"]) return;
  try {
    
  (function() {
    if (window.__solanaWatchRequestBound) return;
    window.__solanaWatchRequestBound = true;

    const form = document.getElementById('solana-request-form');
    if (!form) return;

    form.setAttribute('data-nocaptcha', 'true');

    const params = new URLSearchParams(window.location.search);
    const watchRequested = (params.get('SQF_WATCH_REQUESTED') || '').trim();
    const heading = document.getElementById('solana-request-heading');
    const hiddenWatchTitle = document.getElementById('solana-request-watch-title-hidden');
    const hiddenSubject = form.querySelector('[data-contact-subject]');
    const syncMarker = form.querySelector('[data-lead-alert-sync]');
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const referralSource = form.querySelector('#solana-request-referral-source');

    function validateReferralSource() {
      if (!referralSource) return;

      referralSource.setCustomValidity(referralSource.value.trim() ? '' : referralSource.dataset.requiredMessage);
    }

    if (referralSource) {
      referralSource.addEventListener('input', validateReferralSource);
    }

    function updateSubject() {
      if (!hiddenSubject) return;

      const firstName = (form.querySelector('[name="contact[first_name]"]')?.value || '').trim();
      const lastName = (form.querySelector('[name="contact[last_name]"]')?.value || '').trim();
      const fullName = [firstName, lastName].filter(Boolean).join(' ');
      hiddenSubject.value = watchRequested
        ? 'Watch inquiry: ' + watchRequested
        : fullName ? 'Watch inquiry from ' + fullName : 'Watch inquiry';
    }

    function getFieldValue(names) {
      for (const name of names) {
        const field = Array.prototype.find.call(form.elements, function(element) {
          return element.name === name;
        });

        if (field && typeof field.value === 'string' && field.value.trim() !== '') {
          return field.value.trim();
        }
      }

      return '';
    }

    function createSubmissionId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      return 'watch-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    }

    function setSubmitLoading(isLoading) {
      if (!submitButton) return;

      if (!submitButton.dataset.originalText) {
        submitButton.dataset.originalText = submitButton.textContent || submitButton.value || 'Submit';
      }

      submitButton.disabled = isLoading;

      if (submitButton.tagName === 'INPUT') {
        submitButton.value = isLoading ? 'Submitting...' : submitButton.dataset.originalText;
        return;
      }

      submitButton.textContent = isLoading ? 'Submitting...' : submitButton.dataset.originalText;
    }

    function showFormMessage(message, isError) {
      const existing = form.querySelector('[data-lead-alert-message]');
      const notice = existing || document.createElement(isError ? 'div' : 'p');
      notice.setAttribute('data-lead-alert-message', '');
      notice.className = isError ? 'solana-request__errors' : 'solana-request__success';
      notice.textContent = message;
      form.classList.toggle('solana-request__form--submitted', !isError);

      if (!existing) {
        form.insertBefore(notice, form.firstElementChild);
      }
    }

    function getFieldLabel(fieldWrapper, fallback) {
      const label = fieldWrapper && (fieldWrapper.querySelector('.solana-request__sublabel') || fieldWrapper.querySelector('.solana-request__label'));
      if (!label) return fallback || 'Field';

      return label.textContent
        .replace(/\s*\(required\)\s*/ig, '')
        .replace(/\s+/g, ' ')
        .trim() || fallback || 'Field';
    }

    function collectFormFields() {
      const rows = [];

      Array.prototype.forEach.call(form.querySelectorAll('.solana-request__field, .solana-request__field-group:not(.solana-request__field-group--name)'), function(fieldWrapper) {
        const controls = Array.prototype.slice.call(fieldWrapper.querySelectorAll('input, select, textarea')).filter(function(control) {
          const type = (control.type || '').toLowerCase();
          return type !== 'hidden' && type !== 'submit' && type !== 'button';
        });

        if (!controls.length) return;

        const label = getFieldLabel(fieldWrapper, controls[0].name || controls[0].id);
        const values = [];

        controls.forEach(function(control) {
          const type = (control.type || '').toLowerCase();

          if ((type === 'checkbox' || type === 'radio') && !control.checked) return;
          if (typeof control.value !== 'string') return;

          values.push(control.value.trim());
        });

        rows.push({
          label: label,
          name: controls[0].name || controls[0].id || '',
          value: values.filter(Boolean).join(', ')
        });
      });

      return rows;
    }

    function submitLeadAlert() {
      if (!syncMarker) {
        return Promise.reject(new Error('Missing lead endpoint.'));
      }

      const endpoint = syncMarker.getAttribute('data-customer-sync-url');
      const payload = {
        mode: 'send_inquiry',
        first_name: getFieldValue(['contact[first_name]']),
        last_name: getFieldValue(['contact[last_name]']),
        email: getFieldValue(['contact[email]']),
        phone: getFieldValue(['contact[phone]']),
        inquiry_type: syncMarker.getAttribute('data-inquiry-type') || 'Watch Request',
        fields: collectFormFields(),
        submission_id: createSubmissionId()
      };

      if (hiddenWatchTitle && hiddenWatchTitle.value) {
        payload.fields.push({
          label: 'Watch Requested',
          name: 'contact[Watch Requested]',
          value: hiddenWatchTitle.value
        });
      }

      if (!endpoint) {
        return Promise.reject(new Error('Missing lead endpoint.'));
      }

      if (!payload.email) {
        return Promise.reject(new Error('Please enter a valid email before submitting.'));
      }

      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function(response) {
        if (!response.ok) {
          throw new Error('Could not send watch inquiry.');
        }

        return response.json();
      }).then(function(data) {
        if (!data || data.email_sent !== true) {
          throw new Error('Watch inquiry email was not confirmed.');
        }

        return data;
      });
    }

    if (watchRequested) {
      if (heading) {
        heading.textContent = 'Request more information about ' + watchRequested;
      }
      if (hiddenWatchTitle) {
        hiddenWatchTitle.value = watchRequested;
      }
    } else if (heading && heading.dataset.defaultHeading) {
      heading.textContent = heading.dataset.defaultHeading;
    }

    updateSubject();
    form.addEventListener('input', updateSubject);
    form.addEventListener('change', updateSubject);

    form.addEventListener('submit', function(event) {
      updateSubject();

      const honeypot = document.getElementById('solana-request-website');
      if (honeypot && honeypot.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (!syncMarker) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      validateReferralSource();
      if (!form.reportValidity()) return;

      if (form.dataset.leadAlertPending === 'true') return;
      form.dataset.leadAlertPending = 'true';
      setSubmitLoading(true);

      submitLeadAlert().then(function() {
        form.dataset.leadAlertPending = 'false';
        setSubmitLoading(false);
        showFormMessage('Thank you for reaching out. Someone will be in touch with you shortly.', false);
        form.reset();
        if (hiddenWatchTitle && watchRequested) {
          hiddenWatchTitle.value = watchRequested;
        }
        updateSubject();
      }).catch(function(error) {
        form.dataset.leadAlertPending = 'false';
        setSubmitLoading(false);
        showFormMessage(error.message || 'We could not send the inquiry. Please try again.', true);
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-accordion]').forEach(function(accordion) {
    var items = accordion.querySelectorAll('[data-faq-item]');

    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (item.open) {
          items.forEach(function(other) {
            if (other !== item && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-carousel]').forEach(function(section) {
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;

    var autoScroll = section.dataset.autoScroll === 'true';
    var scrollSpeed = parseInt(section.dataset.scrollSpeed, 10) || 3;
    var scrollDirection = section.dataset.scrollDirection || 'left';
    var desktopVisible = parseInt(section.dataset.desktopVisible, 10) || 5;
    var mobileVisible = parseInt(section.dataset.mobileVisible, 10) || 2;

    var originalSlides = Array.from(track.children);
    var totalOriginal = originalSlides.length;
    if (totalOriginal === 0) return;

    var currentIndex = 0;
    var autoplayInterval = null;
    var isTransitioning = false;

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w > 1000) return desktopVisible;
      if (w >= 601) return Math.max(1, desktopVisible - 1);
      return mobileVisible;
    }

    /* Clone slides for infinite loop */
    var cloneCount = Math.max(desktopVisible, mobileVisible);
    for (var i = 0; i < cloneCount; i++) {
      var cloneEnd = originalSlides[i % totalOriginal].cloneNode(true);
      cloneEnd.setAttribute('aria-hidden', 'true');
      track.appendChild(cloneEnd);
    }
    for (var j = 0; j < cloneCount; j++) {
      var cloneStart = originalSlides[totalOriginal - 1 - (j % totalOriginal)].cloneNode(true);
      cloneStart.setAttribute('aria-hidden', 'true');
      track.insertBefore(cloneStart, track.firstChild);
    }

    /* Set initial position to skip prepended clones */
    currentIndex = cloneCount;
    setPosition(false);

    function setPosition(animate) {
      var visible = getVisibleCount();
      var slideWidth = 100 / visible;
      if (!animate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.5s ease';
      }
      track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + '%)';
    }

    function goTo(index, animate) {
      currentIndex = index;
      isTransitioning = animate;
      setPosition(animate);
    }

    function next() {
      if (isTransitioning) return;
      goTo(currentIndex + 1, true);
    }

    function prev() {
      if (isTransitioning) return;
      goTo(currentIndex - 1, true);
    }

    /* Handle infinite loop boundary */
    track.addEventListener('transitionend', function() {
      isTransitioning = false;
      var visible = getVisibleCount();

      /* Jumped past the end clones — wrap to start */
      if (currentIndex >= totalOriginal + cloneCount) {
        currentIndex = cloneCount;
        setPosition(false);
      }
      /* Jumped before the start clones — wrap to end */
      if (currentIndex < cloneCount) {
        currentIndex = totalOriginal + cloneCount - 1;
        setPosition(false);
      }
    });

    /* Force reflow after no-transition jump */
    function forceReflow() {
      void track.offsetHeight;
    }

    prevBtn.addEventListener('click', function() { prev(); resetAutoplay(); });
    nextBtn.addEventListener('click', function() { next(); resetAutoplay(); });

    /* Auto-scroll */
    function startAutoplay() {
      if (!autoScroll) return;
      autoplayInterval = setInterval(function() {
        if (scrollDirection === 'left') {
          next();
        } else {
          prev();
        }
      }, scrollSpeed * 1000);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    /* Touch/swipe support */
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var isSwiping = false;

    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDeltaX = 0;
      isSwiping = false;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      touchDeltaX = dx;
      if (Math.abs(dx) > Math.abs(dy)) {
        isSwiping = true;
        /* Real-time tracking: move track to follow finger */
        var visible = getVisibleCount();
        var slideWidth = 100 / visible;
        var baseOffset = currentIndex * slideWidth;
        var dragPx = dx;
        var trackWidth = track.parentElement.offsetWidth;
        var dragPct = (dragPx / trackWidth) * 100;
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (-baseOffset + dragPct) + '%)';
      }
    }, { passive: true });

    track.addEventListener('touchend', function() {
      if (isSwiping && Math.abs(touchDeltaX) > 50) {
        if (touchDeltaX < 0) {
          next();
        } else {
          prev();
        }
      } else {
        /* Snap back if swipe was too small */
        setPosition(true);
      }
      startAutoplay();
    });

    /* Resize handler */
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        setPosition(false);
      }, 150);
    });

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');

    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open');
      document.documentElement.style.overflow = expanded ? '' : 'hidden';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-image-slider]').forEach(function(section) {
    var track = section.querySelector('[data-slider-track]');
    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var dots = section.querySelectorAll('[data-slider-dot]');

    if (!track) return;

    var slides = track.children;
    var currentIndex = 0;
    var slideCount = slides.length;
    var autoplayInterval;

    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, slideCount - 1));
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

      dots.forEach(function(dot, i) {
        dot.classList.toggle('image-slider__dot--active', i === currentIndex);
      });
    }

    function next() {
      goToSlide(currentIndex >= slideCount - 1 ? 0 : currentIndex + 1);
    }

    function prev() {
      goToSlide(currentIndex <= 0 ? slideCount - 1 : currentIndex - 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { next(); resetAutoplay(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(dot.getAttribute('data-slider-dot'), 10));
        resetAutoplay();
      });
    });

    function startAutoplay() {
      autoplayInterval = setInterval(next, 5000);
    }

    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }

    section.addEventListener('mouseenter', function() { clearInterval(autoplayInterval); });
    section.addEventListener('mouseleave', startAutoplay);

    if (slideCount > 1) startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"] && !Shopify.designMode) return;
  try {
    
  /* Gallery: thumbnail click + arrow cycling + slide counter */
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
    var mainImg = gallery.querySelector('#main-product-image');
    var thumbs = gallery.querySelectorAll('[data-thumb-index]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var counterEl = gallery.querySelector('[data-gallery-counter]');

    if (!mainImg || thumbs.length === 0) return;

    /* Preload full-size images so arrow / thumb clicks swap instantly */
    thumbs.forEach(function(thumb) {
      var preload = new Image();
      var srcset = thumb.getAttribute('data-thumb-srcset');
      if (srcset) {
        preload.sizes = '(max-width: 767px) 100vw, 50vw';
        preload.srcset = srcset;
      }
      preload.src = thumb.getAttribute('data-thumb-src');
    });

    var currentIndex = 0;
    var total = thumbs.length;

    function setCurrentImage(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      currentIndex = index;

      var thumb = thumbs[currentIndex];
      mainImg.src = thumb.getAttribute('data-thumb-src');
      mainImg.srcset = thumb.getAttribute('data-thumb-srcset');

      thumbs.forEach(function(t) {
        t.classList.remove('product-detail__thumb--active');
      });
      thumb.classList.add('product-detail__thumb--active');

      if (counterEl) {
        counterEl.textContent = (currentIndex + 1) + ' / ' + total;
      }
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        setCurrentImage(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        setCurrentImage(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        setCurrentImage(currentIndex + 1);
      });
    }
  });

  /* Product FAQ */
  document.querySelectorAll('[data-product-faq-item]').forEach(function(item) {
    item.addEventListener('toggle', function() {
      if (!item.open) return;

      document.querySelectorAll('[data-product-faq-item]').forEach(function(otherItem) {
        if (otherItem !== item) {
          otherItem.open = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
